import { IMarkerInput, MarkerTypes } from './types';

export const getMarkerZIndex = (type: MarkerTypes, isSelected?: boolean) => {
  const MarkerZIndexLevels = {
    USER: 3,
    FOCUSED: 2,
    SELECTED: 1,
    DEFAULT: 0,
  } as const;

  if (type === MarkerTypes.User || type === MarkerTypes.UserManual) {
    return MarkerZIndexLevels.USER;
  }
  if (
    type === MarkerTypes.StoreFocused ||
    type === MarkerTypes.StoreFocusedSelected ||
    type === MarkerTypes.StoreFocusedNotAvailable
  ) {
    return MarkerZIndexLevels.FOCUSED;
  }
  if (isSelected) {
    return MarkerZIndexLevels.SELECTED;
  }
  return MarkerZIndexLevels.DEFAULT;
};

// this is just for mobile apps as after some research most of the performance issues was caused by SVG images
export const getKeyForMarkerInput = (
  { type, location }: IMarkerInput,
  isSingleUseMarker: boolean
): string => (isSingleUseMarker ? type : `${location.lat}${location.lng}`);

export const checkSingleUseMarker = (type: MarkerTypes): boolean =>
  [MarkerTypes.User, MarkerTypes.UserManual, MarkerTypes.Driver, MarkerTypes.Destination].includes(
    type
  );

export const svgToUri = (svg: string): string => {
  const base64Svg = Buffer.from(svg).toString('base64');
  return `data:image/svg+xml;base64,${base64Svg}`;
};
